import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";


class SubItem3 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item3">
                <Row style={{backgroundColor: "fff", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={4}>
                        
                    </Col>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Perfil del egresado</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El Publicista Mercadologo formado en nuestra institución es un profesional integral, competitivo, capacitado para planificar, gestionar, evaluar, liderar, desde una perspectiva ética, los Planes de Mercadeo y Estrategias Comunicacionales que contribuyan al desarrollo integral de las organizaciones.
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem3;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/SubItem3.jsx